@if (showBadge) {
  <span [ngClass]="['ft-badge-text', badgeColorCssClass]">{{ badgeText }}</span>
} @else {
  <span class="no-data">{{ badgeText }}</span>
}
